import { Suspense, useContext, lazy, useState, useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ObjectPageContext } from '../../pages/Context/ObjectPageContext';
import { ViewingDto } from '~js/React/services/generatedApi';
import { EstateStatuses } from '~js/React/Enums';
const ViewingBooking = lazy(() => import('../../forms/ViewingBooking'));
const InterestForm = lazy(() => import('../../forms/InterestForm'));
const ViewingItem = lazy(() => import('../../forms/ViewingItem'));

export default function ObjectViewing() {
  const [selectedViewing, setSelectedViewing] = useState<string>();
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideBookModal, setShowHideBookModal] = useState(false);

  const [dataLayerClick, setDataLayerClick] = useState<boolean>(false);
  const [oneViewingDate, setOneViewingDate] = useState<boolean>(false);

  const [hasBookableViewing, setHasBookableViewing] = useState<boolean>(false);

  const [hasRegularViewing, setHasRegularViewing] = useState<boolean>(false);
  const { objectId, estate, setOneViewing, oneViewing } =
    useContext(ObjectPageContext);

  useEffect(() => {
    if (
      estate?.viewings &&
      estate?.viewings.length === 1 &&
      estate?.viewings[0]?.timeSlots?.length === 1 &&
      oneViewing === false
    ) {
      setOneViewing(true);
    }
    if (estate?.viewings && estate?.viewings?.length === 1) {
      setOneViewingDate(true);
    }
  }, [estate?.viewings]);

  return (
    <>
      <div className="pt-4 lg:pt-4 lg:pb-0">
        <div className="px-4 xxl:px-6">
          {hasRegularViewing && (
            <h3 className="font-icb text-blue700 text-xl">
              {oneViewingDate && hasRegularViewing && <span>Visning</span>}
              {hasRegularViewing && !oneViewingDate && <span>Visningar</span>}
            </h3>
          )}
          {estate?.viewings &&
            estate?.viewings !== undefined &&
            estate?.status.name != EstateStatuses.Sold &&
            estate?.status.name != EstateStatuses.SoldOut && (
              <div className={`${hasRegularViewing ? 'mb-4' : ''}`}>
                <Suspense>
                  {estate?.viewings.map((viewing: ViewingDto) => (
                    <div
                      key={viewing?.id}
                      data-id={viewing.id}
                      className="inline-block w-full viewing-item"
                    >
                      <>
                        {!hasRegularViewing && setHasRegularViewing(true)}
                        {!hasBookableViewing &&
                          viewing.bookableFromInternet &&
                          !viewing.fullyBooked &&
                          new Date(viewing.noLaterThen) > new Date() &&
                          setHasBookableViewing(true)}
                        <ViewingItem
                          viewing={viewing}
                          setShowHideModalFunction={setShowHideModal}
                          setSelectedViewingFunction={setSelectedViewing}
                        ></ViewingItem>
                      </>
                    </div>
                  ))}
                </Suspense>
              </div>
            )}
        </div>
        <div className="px-4 xxl:px-6">
          {hasBookableViewing &&
            estate?.status.name != EstateStatuses.Sold &&
            estate?.status.name != EstateStatuses.SoldOut && (
              <button
                className="bg-blue700 mt-4 mb-2 px-3 py-3 rounded-md w-full font-icb text-white viewing-booking-button hover-darken-blue"
                onClick={(e) => {
                  setShowHideModal(true);
                  setDataLayerClick(true);
                }}
              >
                Boka visning
              </button>
            )}
          {(!estate?.viewings ||
            estate?.viewings?.length == 0 ||
            !hasBookableViewing) &&
            estate != null &&
            estate?.status.name != EstateStatuses.Sold &&
            estate?.status.name != EstateStatuses.SoldOut && (
              <>
                <h3 className="font-icb text-blue700 text-xl">
                  Intresseanmälan
                </h3>
                <p className="mb-2 text-black500 text-tiny leading-4">
                  Anmäl ditt intresse så håller vi dig uppdaterad.
                </p>
              </>
            )}
          {(!estate?.viewings || !hasBookableViewing) &&
            estate != null &&
            estate?.status.name != EstateStatuses.Sold &&
            estate?.status.name != EstateStatuses.SoldOut && (
              <button
                className="bg-blue700 mt-2 mb-2 px-3 py-3 rounded-md w-full font-icb text-white viewing-booking-button hover-darken-blue"
                onClick={(e) => {
                  setShowHideBookModal(true);
                  setDataLayerClick(true);
                }}
              >
                Anmäl intresse
              </button>
            )}
          {showHideModal && (
            <Suspense>
              <ViewingBooking
                setShowHideModalFunction={setShowHideModal}
              ></ViewingBooking>
            </Suspense>
          )}
          {showHideBookModal && (
            <Suspense>
              <InterestForm
                customerId={'S13117'}
                estateAddress={estate?.addressInfo?.streetAddress}
                estateId={objectId}
                estateCity={estate?.addressInfo?.city}
                agentEmail={estate?.brokers[0]?.email}
                estateType={estate?.estateTypeAsString}
                setShowHideModalFunction={setShowHideBookModal}
              ></InterestForm>
            </Suspense>
          )}
        </div>
        {dataLayerClick && (
          <HelmetProvider>
            <Helmet>
              <script>
                {`
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'intresseklick',
                'eventInfo': {
                    'intressetyp': '${
                      hasBookableViewing
                        ? 'Visning'
                        : estate?.estateTypeAsString === 'Nyproduktion'
                        ? 'Nyproduktion'
                        : 'Intresse'
                    }'
                }
            });
          `}
              </script>
            </Helmet>
          </HelmetProvider>
        )}
      </div>
    </>
  );
}
